import { takeLatest, put, call, select } from 'redux-saga/effects';
import { GET_SUBSCRIPTION_DURATION_SAGA } from "../sagaTypes";
import { loaderAction, subscriptionDurationFormAction, typeOpenSettingsFormAction } from "../rootReducer";
import { url } from "../../config";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";

const request = data => {
    return fetch(`${ url }/get_subscription_duration`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerGetSubscriptionDuration(args) {
    const user = yield select(state => state.user);

    yield put(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);

        formData.append('id', args.data.id);

        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            // Добавляем данные о типе абонемента в форму
            yield put(subscriptionDurationFormAction(response.duration));
            // Открываем форму редактирования типа абонемента
            yield put(typeOpenSettingsFormAction('duration'));
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherGetSubscriptionDuration() {
    yield takeLatest(GET_SUBSCRIPTION_DURATION_SAGA, workerGetSubscriptionDuration);
}